<template>
  <div class="flex grow flex-col gap-0.5">
    <div
      class="bg-surface-container rounded-t-large rounded-b-extra-small flex h-13 flex-row items-center pr-1.5 pl-4"
    >
      <h3 class="text-title-medium grow">{{ $t('dialog.evaluation.slide.texts') }}</h3>
      <BaseTextButton
        v-if="selectedQuestions.length > 0"
        color="tonalPrimary"
        icon="edit"
        size="S"
        class="mx-auto"
        @click="openDialog"
        >Anpassen</BaseTextButton
      >
    </div>
    <div
      v-if="selectedQuestions.length == 0"
      class="rounded-t-extra-small rounded-b-large bg-surface-container flex w-full items-center justify-center p-4"
    >
      <BaseIconButton
        color="tonalPrimary"
        icon="add"
        size="M"
        width="wide"
        class="mx-auto"
        @click="openDialog"
      />
    </div>
    <ul v-else class="flex flex-col gap-0.5">
      <li
        v-for="selectedQuestion in selectedQuestions"
        :key="selectedQuestion.question.id"
        class="bg-surface-container-low rounded-extra-small last:rounded-b-large w-full p-4"
      >
        <h4 class="text-body-large text-on-surface-variant mb-2">
          {{ selectedQuestion.question.content }}
        </h4>
        <TextFeedbacksForPerspectives :perspectives="selectedQuestion.perspectives" />
      </li>
    </ul>
    <SelectTextFeedbacksDialog
      :title="$t('dialog.evaluation.slide.texts')"
      :is-open="isOpen"
      :texts="texts"
      :initial-feedback-ids="selectedFeedbackIds"
      @close="closeDialog"
      @select-feedbacks="selectFeedbacks"
    />
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue'
  import type { TextAnalysis } from '@/core/models/surveys-analytics'
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import BaseIconButton from '@/core/components/base/button/icon-button/BaseIconButton.vue'
  import { useDialog } from '@/core/components/base/dialog/use-dialog'
  import SelectTextFeedbacksDialog from './SelectTextFeedbacksDialog.vue'
  import TextFeedbacksForPerspectives from '@/core/components/analytics/text-feedback/TextFeedbacksForPerspectives.vue'

  interface Props {
    texts: ReadonlyArray<TextAnalysis>
  }

  const selectedFeedbackIds = defineModel<string[]>({ required: true })

  const props = defineProps<Props>()

  const selectedQuestions = computed(() => {
    return props.texts
      .map((text) => ({
        ...text,
        perspectives: text.perspectives
          .map((perspective) => ({
            ...perspective,
            texts: perspective.texts.filter((t) => selectedFeedbackIds.value.includes(t.id)),
          }))
          .filter((perspective) => perspective.texts.length > 0),
      }))
      .filter((text) => text.perspectives.length > 0)
  })

  const { isOpen, openDialog, closeDialog } = useDialog()

  const selectFeedbacks = (feedbackIds: string[]) => {
    selectedFeedbackIds.value = feedbackIds
  }
</script>
